
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { CmsEntityTypes } from '@/enums/global/CmsEntityTypes';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import UserRightsCopier from '@/components/views/CmsShow/UserRightsCopier.vue';

@Component({
    name: 'CmsUserTable',
    components: {
        UserRightsCopier,
    },
})
export default class CmsUserTable extends Vue {
    @Prop({ type: Object, required: false, default: () => ({}) }) readonly entityData!: any;
    @Prop({ type: Boolean, required: false, default: false }) readonly showArchived!: boolean;

    private search: string = '';

    private get columns() {
        return [
            {
                title: this.$t('Name'),
                dataIndex: 'name',
                scopedSlots: { customRender: 'name' },
                sortDirections: ['descend', 'ascend'],
                __this: this,
                sorter: (a: any, b: any) => a.name.localeCompare(b.name),
                customCell: (record: any): object => {
                    return {
                        on: {
                            click: async () => {
                                const navigationItem = {
                                    entityId: record.id,
                                    additionalEntityId: null,
                                };
                                this.$emit(EventBusEvents.openEntityIndex, navigationItem);
                            },
                        },
                    };
                },
            },
            {
                title: this.$t('Email'),
                dataIndex: 'email',
                scopedSlots: { customRender: 'email' },
                sortDirections: ['descend', 'ascend'],
                __this: this,
                sorter: (a: any, b: any) => a.name.localeCompare(b.name),
                customCell: (record: any): object => {
                    return {
                        on: {
                            click: async () => {
                                const navigationItem = {
                                    entityId: record.id,
                                    additionalEntityId: null,
                                };
                                this.$emit(EventBusEvents.openEntityIndex, navigationItem);
                            },
                        },
                    };
                },
            },
            {
                title: this.$t('Type'),
                dataIndex: 'userType',
                scopedSlots: { customRender: 'userType' },
                __this: this,
                sorter: (a: any, b: any) => a.name.localeCompare(b.name),
                customCell: (record: any): object => {
                    return {
                        on: {
                            click: async () => {
                                const navigationItem = {
                                    entityId: record.id,
                                    additionalEntityId: null,
                                };
                                this.$emit(EventBusEvents.openEntityIndex, navigationItem);
                            },
                        },
                    };
                },
            },
            {
                title: this.$t('Roles'),
                dataIndex: 'roles',
                scopedSlots: { customRender: 'roles' },
                __this: this,
                sorter: (a: any, b: any) => a.name.localeCompare(b.name),
                customCell: (record: any): object => {
                    return {
                        on: {
                            click: async () => {
                                const navigationItem = {
                                    entityId: record.id,
                                    additionalEntityId: null,
                                };
                                this.$emit(EventBusEvents.openEntityIndex, navigationItem);
                            },
                        },
                    };
                },
            },
        ];
    }

    private get filteredList(): any[] {
        if (!this.entityData || !this.entityData.dataSource) {
            return [];
        }
        return this.entityData.dataSource.filter((user: any) => {
            return user.name.toLowerCase().includes(this.search.toLowerCase()) && this.showArchived === user.isArchived;
        });
    }

    private get total(): number {
        return this.filteredList.length;
    }

    private onEditChecklistField(item: any) {
        const navigationItem = {
            entityId: item.id,
            additionalEntityId: null,
        };

        if (this.$route.params.entityName === CmsEntityTypes.PdfOfferOptions) {
            navigationItem.additionalEntityId = item.offerPdfProperties_id;
        }

        if (this.$route.params.entityName === CmsEntityTypes.PdfOrderTemplatesOptions) {
            navigationItem.additionalEntityId = item.orderPdfProperties_id;
        }

        this.$emit(EventBusEvents.openEntityIndex, navigationItem);
    }
}
